import React from 'react';
import { createSvgIcon } from '../helpers';
export var ArrowDownIcon = createSvgIcon(React.createElement("path", {
  fill: 'currentColor',
  d: 'M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z'
}), 'ArrowDown');